<template>
  <div class="video-player-container">
    <iframe
      v-if="video.iframe_url"
      :src="`${video.iframe_url}?${sessionQueryString}`"
      allow="accelerometer; gyroscope; autoplay; encrypted-media;"
      allowfullscreen="true"
    />
    <jw-player v-else :video="video" />
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

import JwPlayer from "@/components/files/JwPlayer.vue"

export default {
  components: {
    JwPlayer
  },
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(useUserSessionStore, ["sessionQueryString"])
  }
}
</script>

<style lang="scss" scoped>
iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
